import { Box, Button, Flex } from "@chakra-ui/react";
import { taskService } from "api/ai/ai.service";
import { RightSidebarHeader } from "components/Layout/RightSidebarWidget";
import { LabelText, ValueText } from "components/text/TextTypes";
import { formatDate } from "utils";
import AIProgressWidget from "./AIProgressWidget";

/**
 * @param {Object} p
 * @param {AITask} p.task
 */
export default function AITaskDetailsRSidebar({ task }) {
  console.log(task); // for debug

  const handleCancel = () => {
    taskService.cancel(task.id);
  };

  // get user name from user_id

  return (
    <Box id="AITaskDetailsPanel" h="full">
      <RightSidebarHeader>{task.task_type}</RightSidebarHeader>
      <Flex direction="column" justify="space-between" h="95%">
        <Box>
          <LabelText>ID</LabelText>
          <ValueText>{task.id}</ValueText>
        </Box>

        <Box>
          <LabelText>Label</LabelText>
          <ValueText>{task.name}</ValueText>
        </Box>

        <Box>
          <LabelText>User</LabelText>
          <ValueText>{task.user_id}</ValueText>
        </Box>

        <Box>
          <LabelText>Status</LabelText>
          <ValueText>{task.status}</ValueText>
        </Box>

        <Box>
          <LabelText>Progress</LabelText>
          <AIProgressWidget task={task} refetchInterval={5000} />
        </Box>

        <Box>
          <LabelText>Created date</LabelText>
          <ValueText>{formatDate(task.created_date)}</ValueText>
        </Box>

        <Box>
          <LabelText>Completed date</LabelText>
          <ValueText>{formatDate(task.completed_date)}</ValueText>
        </Box>

        <Box>
          <LabelText>Inputs</LabelText>
          <ValueText>{JSON.stringify(task.inputs)}</ValueText>
        </Box>

        <Box>
          <LabelText>Outputs</LabelText>
          <ValueText>{task.outputs && Object.keys(task.outputs).join(", ")}</ValueText>
        </Box>

        {task.error && (
          <Box>
            <LabelText color="red">Error</LabelText>
            <ValueText>{task.error}</ValueText>
          </Box>
        )}

        <Flex gap={2} direction="column">
          <Button colorScheme="red" onClick={handleCancel}>
            Cancel
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
}
